import { type Locale, useFormatNumber } from '@finn-no/number-format';
import { Trans } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';
import type { PriceWidgetModel } from '../../../types/widget.js';

type PriceWidgetProps = Pick<PriceWidgetModel, 'className' | 'suffix'> & {
  locale: Locale;
};

export const PriceWidget = (props: PriceWidgetProps) => {
  const { watch } = useFormContext();

  const watchedRegistrationPrice = watch('price.registration_price');
  const watchedRegistrationTaxExemption = watch('price.registration_tax_exemption');

  const watchedNetPrice = watch('price.net');

  const registrationPrice = Number.isFinite(watchedRegistrationPrice) ? watchedRegistrationPrice : 0;
  const netPrice = Number.isFinite(watchedNetPrice) ? watchedNetPrice : 0;

  const showTotalPriceWithoutTax = watchedRegistrationTaxExemption === 'YES' || watchedRegistrationTaxExemption === 1;
  const formatNumber = useFormatNumber(props.locale);
  const totalPrice = netPrice + (showTotalPriceWithoutTax ? 0 : registrationPrice);
  const formattedTotalPrice = formatNumber(totalPrice);

  return (
    <div className={props.className}>
      <label className="block font-bold text-s mb-16" htmlFor="total-price">
        <Trans id="mobility-item-insertion.form.price.total.label">Total searchable price</Trans>
      </label>
      <p id="total-price">
        {formattedTotalPrice} {props.suffix}
      </p>
    </div>
  );
};
